'use strict';

var Params = function Params() {
  return function (containerWidth) {
    var padding = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    var height = 34;
    var width = containerWidth - (padding.left + padding.right);
    return {
      width: width,
      forceHeight: true,
      height: height,
      containerWidth: containerWidth,
      containerHeight: height + padding.top + padding.bottom,
      padding: padding,
      xAxisShift: 0,
      direction: 'vertical',
      yAxisShift: 0
    };
  };
};
module.exports = Params;